import { api } from '@/api'
import Button from '@/components/Button'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import Section from '@/components/Section'
import Tag from '@/components/Tag'
import Title from '@/components/Title'
import { useCurrentUser, useModal } from '@/hooks'
import {
  arrowRightIcon,
  championshipStar,
  championshipTrophy,
  championshipWaiting,
  gameIcon,
  trophyIcon
} from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import style from '../styles/champ_detail.module.scss'

interface IProps {
  gameInfo: any
  championship: any
  ageValue: string | undefined
  title: string
  gameDetailUrl: string | undefined
  gameDescription: string | null
}

const ChampionshipInfo = ({
  gameInfo,
  ageValue,
  championship,
  title,
  gameDetailUrl,
  gameDescription
}: IProps): React.ReactElement => {
  const [closing, setClosing] = useState(false)
  const { currentUser } = useCurrentUser()
  const { openModal } = useModal()

  const tournamentCodeValue = championship?.property_tournament_code_value
  const tourneyCode = championship?.property_tourney_code_value
  const isFinish = Boolean(Number(championship?.property_is_finished_value))
  const isWaiting =
    Boolean(Number(championship?.property_tourney_register_closed_value)) &&
    !isFinish
  const isOpen = !isWaiting && !isFinish
  const isShowCode = tournamentCodeValue === 'Y'

  const isAdmin = currentUser?.is_admin

  const handleOpenModal = (): void => {
    openModal('championshipCode', {
      tourneyCode
    })
  }

  let correctAge = ''
  if (ageValue !== undefined) {
    if (ageValue.includes('лет')) {
      correctAge = ageValue
    } else {
      correctAge = `${ageValue} лет`
    }
  }

  const handleClose = (): void => {
    if (championship !== undefined) {
      setClosing(true)
      api
        .closeChampionship({
          id: championship.id
        })
        .then(() => window.location.reload())
        .catch(() => setClosing(false))
    }
  }

  return (
    <Section>
      <div className={style.detail_head}>
        <div
          className={classNames({
            [style.status]: true,
            [style.status__open]: isOpen,
            [style.status__completed]: isFinish,
            [style.status__waiting]: isWaiting
          })}
        >
          {isOpen
            ? (
              <>
                <GxIcon src={championshipStar} className={style.status__icon} />
                <span className={style.status__text}>Открыт набор</span>
              </>
              )
            : (
                ''
              )}
          {isFinish
            ? (
              <>
                <GxIcon src={championshipTrophy} className={style.status__icon} />
                <span className={style.status__text}>Завершен</span>
              </>
              )
            : (
                ''
              )}
          {isWaiting
            ? (
              <>
                <GxIcon
                  src={championshipWaiting}
                  className={style.status__icon}
                />
                <span className={style.status__text}>Ожидание завершения</span>
              </>
              )
            : (
                ''
              )}

          <ul className={style.status_tags}>
            {gameInfo !== undefined
              ? (
                <li className={style.status_tags__item}>
                  <Tag theme='white' title={gameInfo.name} />
                </li>
                )
              : (
                  ''
                )}
            {correctAge !== ''
              ? (
                <li className={style.status_tags__item}>
                  <Tag theme='white' title={correctAge} />
                </li>
                )
              : (
                  ''
                )}
          </ul>
        </div>
        <div className={style.detail_info}>
          {championship === undefined ||
          championship?.detail_picture === null
            ? (
              <div
                className={classNames({
                  [style.detail_empty]: true,
                  [style.detail_empty__open]: isOpen,
                  [style.detail_empty__completed]: isFinish,
                  [style.detail_empty__waiting]: isWaiting
                })}
              >
                <GxIcon src={gameIcon} className={style.detail_empty__icon} />
              </div>
              )
            : (
              <img
                src={championship.detail_picture[0]}
                width='270px'
                height='270px'
                alt='Игра'
                className={style.detail__screenshot}
              />
              )}
          <div className={style.detail_info_right}>
            <Title type='h2' className={style.detail__title}>
              {title}
            </Title>
            {gameDetailUrl !== undefined
              ? (
                <Link to={gameDetailUrl} className={style.detail__link}>
                  К игре
                  <GxIcon
                    src={arrowRightIcon}
                    className={style.detail__link_icon}
                  />
                </Link>
                )
              : (
                <PlaceholderLoading shape='rect' width={96} height={24} />
                )}
          </div>
        </div>
        {isOpen && isShowCode && !isAdmin
          ? (
            <Button
              size='large'
              highlight
              wide
              corner
              onClick={handleOpenModal}
              className={style.detail__code}
            >
              Получить код
            </Button>
            )
          : null}
        {isAdmin && !isFinish
          ? (
            <Button
              size='large'
              highlight
              wide
              corner
              className={style.detail__close}
              onClick={handleClose}
              disabled={closing}
            >
              <GxIcon src={trophyIcon} slot='icon-left' />
              Завершить этап
            </Button>
            )
          : null}
      </div>
      {gameDescription !== null && gameDescription.length > 0
        ? (
          <div className={style.detail_desc}>
            <Title type='h2' theme='h3' className={style.detail_desc__title}>
              Описание
            </Title>
            <p className={style.detail_desc__text}>{gameDescription}</p>
          </div>
          )
        : null}
    </Section>
  )
}

export default ChampionshipInfo
